import { call, put } from 'redux-saga/effects';

import request from '../request';
import api from '../../../api';
import actions from '../../../actions';

export function* createCardRelation(cardId, card2Id, type) {
  console.log('SAGA CREATE RELATION');
  yield put(actions.createCardRelation(cardId, card2Id, type));

  let cardRelation;

  try {
    const response = yield call(request, api.createCardRelation, cardId, {
      card2Id,
      type,
    });

    console.log('RESPONSE', response);
    cardRelation = response.item.item;
  } catch (error) {
    yield put(actions.createCardRelation.failure(cardId, card2Id, type, error));

    return;
  }

  yield put(actions.createCardRelation.success(cardRelation));
}

export function* clearCardRelationCreateError() {
  yield put(actions.clearCardRelationCreateError());
}

export function* deleteCardRelation(id) {
  yield put(actions.deleteCardRelation(id));

  let cardRelation;

  try {
    ({ item: cardRelation } = yield call(request, api.deleteCardRelation, id));
  } catch (error) {
    yield put(actions.deleteCardRelation.failure(id, error));

    return;
  }

  yield put(actions.deleteCardRelation.success(cardRelation));
}

export default {
  createCardRelation,
  clearCardRelationCreateError,
  deleteCardRelation,
};
